//import angular from 'angular';
import DbClass from '../../common/local-db';

    angular.module('app.fieldSurveys')
        .service('componentReceiveService', ['baseModuleService', 'amtXlatSvc', '$db', 'errorReporter', '$q', '$timeout', 'fileManagement',
            function (baseModuleService, xlatSvc, $db: DbClass, errorReporter, $q, $timeout, fileManagement) {

                var vm = this;
                var internalName = 'receiveComponent';
                var tableName = 'receive';

                var pendingComponents = false;

                vm = new baseModuleService(internalName, tableName);

                vm.trimForUpload = function (records) {
                    return records[0]; // By default, we pass an array. Component Receive does things 1 at a time.
                };

                vm.getEndpoint = function (records) {
                    if (records.fitComponents) {
                        pendingComponents = true;
                        return 'equipment/component/receivePendingComponents';
                    } else if (records.isKnown) {
                        return 'equipment/component/receiveKnownComponents';
                    } else {
                        return 'equipment/component/receiveUnknownComponents';
                    }
                };

                // update the display details for the module
                vm.updateDetails = function () {

                    // reset to defaults
                    if (!vm.active) {
                        // the description and what not should be set custom in the module.
                        // This could be permissions or something
                        return $q.resolve();
                    }

                    vm.count = 0;
                    vm.intDateDiff = 0;
                    vm.intStatus = '';
                    vm.description = ' --- ';
                    vm.readOnly = (!vm.active);

                    return $db[tableName].where('pristine').notEqual(1).toArray().then(
                        function (records) {
                            var components = records.filter(function (r) { return !r.vehicles; });
                            return vm.updateDescription(components.length).then(function () {
                                $timeout();
                            });
                        }).catch(function (error) {
                            vm.description = 'Error:' + errorReporter.exceptionMessage(error);
                        });
                };

                vm.processErrors = function (response, uploadErrors, postedRecord) {
                    if (response && response.length > 0) {
                        var message = xlatSvc.xlat(internalName + '.elementName') + ' ' +
                            (postedRecord.displayDescription || postedRecord.id) + ':';

                        uploadErrors.push({
                            msg: message,
                            subErrors: response
                        });
                    }
                };

                vm.uploadFiles = async function (record) {

                    if (record) {

                        // attachments shared by multiple components
                        for (let attachment of record.attachments || []) {
                            let file = await fileManagement.uploadFile(attachment.id, false);                            
                            if (file) attachment.id = file.id; // update the file id
                        }

                        // attachments for individual components
                        for (let component of record.components || []) {
                            for (let attachment of component.eventDetails.attachments || []) {
                                let file = await fileManagement.uploadFile(attachment.id, false);                                
                                if (file) attachment.id = file.id; // update the file id
                            }
                        }
                    }
                };

                vm.postProcess = function (record) {

                    // if it was a pending component (3rd party) it needs to be cleared from the pendingComponents table
                    if (pendingComponents) {
                        record.components.forEach(function (c) {
                            if (c.id) {
                                $db.pendingComponents.where('id').equals(c.id).delete();
                            }
                        });
                    }
                    // if this was a known component it needs to be cleared from the pendingReceivals table                    
                    else if (record.isKnown) {
                        record.components.forEach(function (c) {
                            if (c.equipmentId) {
                                $db.pendingReceivals.where('id').equals(c.equipmentId).delete();
                            }
                        });
                    }
                };

                return vm;
            }]);
